<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  export let domain = {};
  export let spf = {};
</script>

<div
  id="domain-spf-{domain._id}"
  class="tag spf"
  class:pass={spf.lookups <= 9 && spf.result === 'pass'}
  class:warn={spf.lookups > 9 && spf.result === 'pass'}
  class:fail={spf.result === 'fail' || spf.result === 'softfail'}
  class:perm={spf.result === 'permerror'}
>
  <i
    class:os-icon-help-circle={spf.lookups === undefined}
    class:os-icon-check={spf.lookups <= 9 && spf.result === 'pass'}
    class:os-icon-alert-triangle={spf.lookups > 9 && spf.result === 'pass'}
    class:os-icon-x-octagon={spf.result === 'fail' || spf.result === 'softfail'}
    class:os-icon-skull={spf.result === 'permerror'}
  />
  SPF
  <Tooltip target="domain-spf-{domain._id}" placement="top">
    {#if spf.lookups === undefined}
      {$format('label.STATUS')}: <b>{$format('label.UNKNOWN')}</b>
    {:else}
      {#if spf.lookups <= 9 && spf.result === 'pass'}
        {$format('label.STATUS')}: <b>{$format('label.GOOD')}</b>
      {:else if spf.lookups > 9 && spf.result === 'pass'}
        {$format('label.STATUS')}: <b>{$format('label.WARNING')}</b>
      {:else if spf.result === 'softfail' || spf.result === 'fail'}
        {$format('label.STATUS')}: <b>{$format('label.ERROR')}</b>
      {:else if spf.result === 'permerror'}
        {$format('label.STATUS')}: <b>{$format('label.PERMANENT_ERROR')}</b>
      {/if}

      <div>{$format('label.LOOKUPS')} {spf.lookups}</div>

      {#if spf.info}
        <div>
          {$format('label.INFO')}
          {spf.info}
        </div>
      {/if}
    {/if}
  </Tooltip>
</div>

<style lang="scss" src="./spf.scss"></style>
